import common from './common/_index';
import pageExpoSummer from './pages/expo-summer/_index';
import pageRenewal from './pages/renewal/_index';

addEventListener('DOMContentLoaded', (): void => {
  // 全ページ共通で行う処理を実行
  common();

  // 各ページ固有の処理を実行
  if (document.getElementById('page-renewal')) pageRenewal();
  if (document.getElementById('page-expo-summer')) pageExpoSummer();
});
